import { Components } from "@thisgorilla/primate-ds";
import { useFormikContext } from "formik";
import { useContext } from "react";
import styled from "styled-components";
import { CreateRepostContext } from "..";
import { API_CALLS } from "../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../redux";
import { RepostProps } from "../../../../../../redux/slices/posts/Repost";
import { getIsARepost } from "../../../../../../utils";
import { ModalContext } from "../../../../../Common/Modal";
import { FlexColumn, FlexRowEnd } from "../../../../../Common/Styles";
import { usePostCardContext } from "../../PostCard/PostCardContent";

export const CreateRepostFooter = () => {
  const { processed_posts } = useAppSelector((store) => store.newsfeed);
  const { footerRef } = useContext(ModalContext);
  const { postId } = usePostCardContext();
  const { setCreateRePostOpen } = useContext(CreateRepostContext);
  const { values } = useFormikContext<RepostProps.formikValues>();

  const post = processed_posts[postId];
  const isARepost = getIsARepost(post.EmbedPostID);

  return (
    <Container ref={footerRef} $gapInPx={16}>
      <Line />
      <ButtonsWrapper>
        <Components.Button
          kind="Primary"
          size="Medium"
          color="Primary"
          disabled={false}
          label="Repost now"
          onClick={() => {
            const payload: RepostProps.repostAPostPayload = {
              node_tree: values.content,
              post_id: isARepost ? post.EmbedPostID : postId,
            };
            API_CALLS.POSTS.repostAPost(payload);
            setCreateRePostOpen(false);
          }}
        />
      </ButtonsWrapper>
    </Container>
  );
};

const Container = styled(FlexColumn)``;
const Line = styled.div`
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
`;
const ButtonsWrapper = styled(FlexRowEnd)``;
